export const DEFAULT_RECORD_LIMIT = 100000;

/** Backend `dataset_size_limit` ceiling (`optuneutils.constants.record_limits`). */
export const MAX_RECORD_LIMIT = 100_000;

/** Inline error for the Limit number of records input, or `''`. */
export const recordLimitErrorText = (recordLimit, { submitAttempted = false } = {}) => {
    if (Number.isFinite(recordLimit) && recordLimit > MAX_RECORD_LIMIT) {
        return `Maximum allowed records: ${MAX_RECORD_LIMIT.toLocaleString('en-US')}`;
    }
    if (submitAttempted && !(Number.isFinite(recordLimit) && recordLimit >= 1)) {
        return 'Enter how many records to retrieve (at least 1).';
    }
    return '';
};

/** Generative example modes (Figma summarization Optional Settings). */
export const EXAMPLE_MODE_ITEMS = [
    { id: 'io', label: 'Input & output' },
    { id: 'output', label: 'Output only' },
];

export const HELP_TEXTS = {
    generationGoal: 'Describe the public data the agent should search for and how it should be prepared.',
    languages: 'Languages the retrieved records should cover.',
    labelDescription: 'When should this label apply? Guides the agent toward unambiguous samples.',
    entityDescription: 'What does this entity type cover? Guides the agent toward clear entity mentions.',
    examples: 'Map an example text to the single label it represents.',
    examplesMultilabel: 'Map an example text to the labels it represents.',
    exampleLabel: 'The label this example represents.',
    exampleLabels: 'The labels this example represents.',
    exampleMode: 'Provide an input/output pair, or a wanted output on its own.',
    recordLimit: 'Maximum number of records the agent should retrieve (up to 100,000).',
    domain: 'Business domain the retrieved content should belong to.',
    provider: 'Model the agent uses to search, filter, and prepare public datasets.',
    toneStyle: 'Tone and writing style preferred in retrieved samples.',
    textLength: 'Approximate length of each retrieved text.',
    contentType: 'Whether retrieved samples are plain text, text with code, or code only.',
    customGuidelines: 'Free-form instructions the agent must follow (terminology, formatting, restrictions).',
    datasetsToExclude: 'Dataset names, sources, or domains the agent must not use.',
};

/** Modal subtitle on the Define Task step (Figma Data Creation). */
export const DEFINE_SUBTITLE =
    'Describe what the dataset should accomplish and refine the labels or entities the agent suggested.';

/** Modal subtitle on the Optional Settings and Review steps (Figma 5074:21555). */
export const CONFIGURE_SUBTITLE =
    'Define what the dataset should teach, then configure the labels and examples that will guide generation.';

export const LOAD_PREVIOUS_LABEL = 'Load Previous Retrieval Configurations';

/** "Description" placeholder on the Define Task step (retrieval-specific). */
export const DESCRIPTION_PLACEHOLDER =
    'Describe the dataset the agent should retrieve from public sources.\n' +
    'Focus on the problem, content type, and selection criteria.\n' +
    'Example: Customer support tickets suitable for urgency classification.';

/** Optional Settings intro shown for generative tasks (Figma 5074:23748). */
export const GENERATIVE_SETTINGS_HINT =
    'Describe the data you need, including the type of input, use case, and any important context.';

export const REVIEW_DESCRIPTION =
    'Confirm the configuration below. The agent will run asynchronously and notify you on completion. ' +
    'You can pause or cancel the agent at any time from the project dashboard.';
